module.exports = __webpack_public_path__ + "static/media/JAcob Baser 2 Pic.8ef35027.jpg";